import React, { useState } from "react";
import {
  Box,
  Typography,
  Modal,
  Button,
  Stack,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import {
  CustomSecondaryButton,
  CustomSuccessButton,
} from "./GlobalButtonComponent";

const StatusModal = ({ open, onClose }) => {
  const [status, setStatus] = useState("Doubtful");

  const handleStatusChange = (event, newStatus) => {
    if (newStatus) setStatus(newStatus);
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          maxWidth: 500,
          p: 2,
          bgcolor: "white",
          borderRadius: 2,
          mx: "auto",
          mt: 10,
          textAlign: "center",
          boxShadow: 24,
        }}
      >
        <Typography
          variant="h5"
          fontWeight="500"
          sx={{ mt: 2, textAlign: "left" }}
        >
          Select Status and Continue
        </Typography>

        <Typography variant="body1" sx={{ mt: 1, p: 2 }}>
          You have completed and approved all the steps. Forward the application
          to the next department to complete the certification process.
        </Typography>

        {/* Select Status */}
        <Typography variant="body1" sx={{ mt: 3, mb: 2 }}>
          Select Status
        </Typography>
        <ToggleButtonGroup
          value={status}
          exclusive
          onChange={handleStatusChange}
          aria-label="Select Status"
          color="primary"
        >
          <Button
            sx={{
              mx: 2,
              borderRadius: "20px",
              px: 3,
              py: 1.5,
              textTransform: "none",
              border: "1px solid",
            }}
            value="Safe"
          >
            Safe
          </Button>

          <Button
            sx={{
              mx: 2,
              borderRadius: "20px",
              px: 3,
              py: 1.5,
              textTransform: "none",
              border: "1px solid",
            }}
            value="Doubtful"
            color="warning"
          >
            Doubtful
          </Button>

          <Button
            sx={{
              mx: 2,
              borderRadius: "20px",
              px: 3,
              py: 1.5,
              textTransform: "none",
              border: "1px solid",
            }}
            value="Critical"
            color="error"
          >
            Critical
          </Button>
        </ToggleButtonGroup>

        {/* Actions */}
        <Stack
          direction="row"
          justifyContent="center"
          spacing={2}
          sx={{ mt: 4 }}
        >
          <CustomSecondaryButton label={"Review Back"} />
          <CustomSuccessButton label={"Move to RND"} />
        </Stack>
      </Box>
    </Modal>
  );
};

export default StatusModal;
